import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import SearchIcon from '@mui/icons-material/Search';
import type { SxProps } from '@mui/material';
import { Box, Button, IconButton, TextField } from '@mui/material';
import { Center, flatSx } from '@ocodelib/mui';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import { useState } from 'react';

interface Props {
  sx?: SxProps;
  className?: string;
  children?: ReactNode;
}

export function SearchBar(props: Props) {
  const { sx, className } = props;
  const [expanded, setExpanded] = useState(false);

  const handleClickSearchBtn = () => {
    //
  };

  return (
    <Box
      className={clsx('SearchBar-root', className, { x_expanded: expanded })}
      sx={flatSx(
        {
          background: '#fff',
          pt: 0.5,
          borderRadius: '5px',
          border: '1px solid #f3f5f8',
          width: '100%',
          '&.x_expanded .SearchBar-searchBox': {
            borderRadius: 1,
            boxShadow: 1,
          },
        },
        sx,
      )}
    >
      <Box
        className="SearchBar-searchBox"
        sx={{
          py: 1,
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Center sx={{ width: 56 }}>
            <IconButton
              color={expanded ? 'secondary' : 'primary'}
              onClick={() => {
                setExpanded((p) => !p);
              }}
            >
              {expanded ? <KeyboardDoubleArrowUpIcon /> : <KeyboardDoubleArrowDownIcon />}
            </IconButton>
          </Center>
          <Box sx={{ flex: 1, display: 'flex' }}>
            <TextField
              fullWidth
              placeholder="검색어"
              autoComplete="off"
              size="small"
              type="search"
              sx={{ pr: expanded ? 2 : 0 }}
            />
            {!expanded && (
              <IconButton sx={{ ml: 1 }} onClick={handleClickSearchBtn}>
                <SearchIcon />
              </IconButton>
            )}
          </Box>
        </Box>
        {expanded && (
          <Box
            sx={{
              mt: 2,
              pl: '56px',
              pr: 2,
            }}
          >
            <TextField fullWidth size="small" />
            <Box sx={{ mt: 2 }}>
              <Button variant="contained" onClick={handleClickSearchBtn}>
                검색
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}
